import React from "react";
import Loader from "../Loader";
import classNames from "../classNames";
import Head from "./Head";
import Body from "./Body";

const noop = () => {
}
const defaultProps = {
    fields: {},
    objects: [],
    excludeFields: [],
    keys: [],
    selected: [],
    progress: false,
    loading: false,
    onClick: noop,
    onClickItem: noop,
    onSelect: noop,
    onSelectAll: noop,
    readOnly: false,
    actions: [],
    actionsList: [],
    selectable: false,
    collapsable: false,
    toggleable: false,
    onCollapse: noop,
    onLongPress: noop
}


function Table({
                   className,
                   fields,
                   objects,
                   loading,
                   progress,
                   onClick,
                   onClickItem,
                   selected,
                   onSelect,
                   onSelectAll,
                   excludeFields,
                   keys,
                   actions,
                   actionsList,
                   setRef,
                   selectable,
                   onCollapse,
                   collapsable,
                   toggleable,
                   onLongPress,
                   ...props
               }) {
    const fieldImage = Object.keys(fields).find(field => fields[field]._type === "Image" && fields[field].read !== false || fields[field].detail);
    loading = loading || progress;// progress is deprecated

    const columns = keys.length > 0 ? keys : Object.keys(fields);

    return (
        <div className="position-relative">
            <div
                className={classNames("table-responsive shadow-sm", className)}
                ref={setRef}
                {...props}>
                <table className="table mb-0 w-100 table-striped">
                    <thead className="table-dark">
                    <Head
                        fields={fields}
                        selectable={selectable}
                        columns={columns}
                        excludes={excludeFields}
                        actionsList={actionsList}
                        selected={selected}
                        onSelectAll={onSelectAll}
                        objects={objects}
                    />
                    </thead>
                    <tbody className="bg-white">
                    {
                        (objects.length === 0 && !loading) && (
                            <tr>
                                <td className="text-center fs-lg" colSpan={Object.keys(fields).length + 1}>
                                    No Data Found
                                </td>
                            </tr>
                        )
                    }
                    <Body
                        objects={objects}
                        fields={fields}
                        columns={columns}
                        excludes={excludeFields}
                        selected={selected}
                        selectable={selectable}
                        onSelect={onSelect}
                        onClick={onClick}
                        onLongPress={onLongPress}
                        actionsList={actionsList}
                        collapsable={collapsable}
                        toggleable={toggleable}
                        onCollapse={onCollapse}
                        actions={actions}
                        onClickItem={onClickItem}
                        fieldImage={fieldImage}
                    />
                    {
                        loading &&
                        <tr>
                            <td colSpan={Object.keys(fields).length + 1}>
                                <Loader className="fs-sm">Loading ...</Loader></td>
                        </tr>
                    }
                    </tbody>
                </table>
            </div>
        </div>

    )
}

Table.defaultProps = defaultProps;
export default Table;
